"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.sort");
var _ModulePopup = _interopRequireDefault(require("./components/ModulePopup.vue"));
var _HeadlineManagementPopup = _interopRequireDefault(require("./components/HeadlineManagementPopup.vue"));
var _HorseRaceLampPopup = _interopRequireDefault(require("./components/HorseRaceLampPopup.vue"));
var _mobileContent = _interopRequireDefault(require("./mobileContent"));
var _creatApp = require("@/api/creatApp");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    MobileContent: _mobileContent.default,
    ModulePopup: _ModulePopup.default,
    HeadlineManagementPopup: _HeadlineManagementPopup.default,
    HorseRaceLampPopup: _HorseRaceLampPopup.default
  },
  props: {},
  data: function data() {
    return {
      outCategory: '',
      dialogVisible: false,
      activeNum: 0,
      diamondTypeList: [],
      options: [{
        value: 0,
        label: '下线'
      }, {
        value: 1,
        label: '上线'
      }],
      baseData: [{
        text: '首页顶部模块',
        isShow: 0,
        myType: 1
      }, {
        text: '首页顶部轮播图',
        isShow: 0,
        category: '2'
      }, {
        text: '首页顶部小轮播图',
        isShow: 0,
        category: '3'
      }, {
        text: '首页金刚区',
        isShow: 0,
        key: 'diamond',
        category: '4'
      }, {
        text: '头条信息',
        isShow: 0,
        category: '5'
      }, {
        text: '首页5连块',
        isShow: 0,
        category: '6'
      }, {
        text: '中部轮播图',
        isShow: 0,
        category: '7'
      }, {
        text: '首页中部4连块',
        isShow: 0,
        category: '8'
      }, {
        text: '首页左侧轮播',
        isShow: 0,
        category: '9'
      }, {
        text: '首页右侧1大4小卡片',
        isShow: 0,
        category: '10'
      }, {
        text: '悬浮窗',
        isShow: 0,
        category: '11'
      }, {
        text: '首页跑马灯',
        isShow: 0,
        category: '12'
      }, {
        text: '商品列表菜单栏',
        isShow: 0,
        myType: 13
      }, {
        text: '底部导航栏',
        isShow: 0,
        myType: 14
      }],
      tableData: [{
        name: '客服图标',
        size: '180*180',
        type: 'customerServiceIcon',
        url: '',
        text: '客服',
        myType: 1,
        isShow: 1
      }, {
        name: '客服弹窗',
        size: '500*600',
        url: ''
      }, {
        name: '消息图标',
        size: '180*180',
        type: 'msgIcon',
        url: '',
        text: '消息'
      }, {
        name: '转链图标',
        size: '180*180',
        type: 'turnIcon',
        url: '',
        text: '转链'
      }, {
        name: '文字色值',
        size: '',
        type: 'textColor',
        color: ''
      }, {
        name: '首页背景',
        size: '750*580',
        type: 'bg',
        url: ''
      }],
      tableDataFour: [{
        name: '商品列表 TAB底色',
        type: 'tbBg',
        color: '',
        myType: 13,
        isShow: 1
      }, {
        name: '字体色值',
        type: 'textColor',
        color: ''
      }, {
        name: '返回顶部图标',
        type: 'goTop',
        url: '',
        size: '120*120'
      }, {
        name: '足迹图标',
        type: 'footIcon',
        url: '',
        size: '120*120'
      }],
      tableDataFif: [{
        name: '首页',
        size: '120*120',
        type: 'home',
        selectUrl: '',
        normalUrl: '',
        myType: 14,
        isShow: 1
      }, {
        name: '吃喝玩乐',
        size: '120*120',
        type: 'local',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '排行榜',
        size: '120*120',
        type: 'rank',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '发圈',
        size: '120*120',
        type: 'hair',
        selectUrl: '',
        normalUrl: ''
      }, {
        name: '我的',
        size: '120*120',
        type: 'mine',
        selectUrl: '',
        normalUrl: ''
      }]
    };
  },
  computed: {
    homeTopList: function homeTopList() {
      return this.tableData;
    },
    homeFootList: function homeFootList() {
      return this.tableDataFour;
    },
    tabBarList: function tabBarList() {
      return this.tableDataFif;
    },
    allConfig: function allConfig() {
      return this.baseData.filter(function (i) {
        return !i.myType;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.getList();
    setTimeout(function () {
      _this.findAll();
    }, 200);
    setTimeout(function () {
      _this.dataBuff();
    }, 500);
  },
  methods: {
    getHeaderMsg: function getHeaderMsg(val) {
      var _this2 = this;
      (0, _creatApp.headerMsg)({
        modelId: val
      }).then(function (res) {
        // console.log(res.data, '=============')
        // for (var i = 0; i < 20; i++) {
        //   console.log(i)
        // }
        res.data.headlineList.map(function (m) {
          m['pic'] = res.data.pic;
        });
        _this2.baseData.map(function (i) {
          if (i.category * 1 === 5) {
            i.bannerList = res.data.headlineList.length > 0 ? res.data.headlineList : [{
              'pic': res.data.pic
            }];
          }
        });
      });
    },
    getHorseList: function getHorseList(val) {
      var _this3 = this;
      (0, _creatApp.horseList)({
        modelId: val
      }).then(function (res) {
        res.data.marqueeList.map(function (m) {
          m['pic'] = res.data.pic;
        });
        _this3.baseData.map(function (i) {
          if (i.category * 1 === 12) {
            i.bannerList = res.data.marqueeList.filter(function (i) {
              return i.enable === 1;
            });
          }
        });
      });
    },
    goBack: function goBack() {
      this.activeNum = 0;
    },
    setting: function setting(val) {
      if (val.category) {
        if (val.category * 1 === 5) {
          this.$refs.HeadlineManagementPopup.open({
            id: val.id
          });
        } else if (val.category * 1 === 12) {
          this.$refs.HorseRaceLampPopup.open({
            id: val.id
          });
        } else {
          this.$refs.ModulePopup.open({
            name: val.text,
            id: val.id,
            region: val.region,
            category: val.category
          });
        }
      } else {
        this.activeNum = val.myType;
      }
    },
    locatinClick: function locatinClick(val) {
      var _this4 = this;
      this.outCategory = val.id;
      (0, _creatApp.getLocations)({
        id: val.id
      }).then(function (res) {
        console.log(res);
        if (res.data) {
          _this4.diamondTypeList = [];
          _this4.diamondTypeList = res.data.map(function (i) {
            return {
              input: i.locationName,
              code: i.locationCode,
              boole: true,
              status: i.enable,
              num: i.sort
            };
          });
        }
      }).then(function () {
        _this4.dialogVisible = true;
      });
    },
    findAll: function findAll() {
      var _this5 = this;
      (0, _creatApp.findAll)({
        region: 1
      }).then(function (res) {
        if (res.data.length === 0) {
          _this5.initData();
        } else {
          res.data.sort(function (a, b) {
            return a.category - b.category;
          });
          var arr = res.data.map(function (i) {
            return {
              text: i.modelName,
              category: i.category,
              isShow: i.enable,
              bannerList: i.bannerList && i.bannerList != null ? i.bannerList : [],
              id: i.id,
              locations: i.locations,
              region: i.region
            };
          });
          // console.log(this.tableData)
          // console.log(

          //   this.tableData.filter(i => { return i.myType * 1 === 1 }), 'hhahah', this.tableDataFour.filter(i => { return i.myType * 1 === 13 })
          // )
          arr.unshift({
            text: '首页顶部模块',
            isShow: _this5.tableData.filter(function (i) {
              return i.myType * 1 === 1;
            }).length > 0 ? _this5.tableData.filter(function (i) {
              return i.myType * 1 === 1;
            })[0].isShow : 0,
            myType: 1
          });
          arr.push({
            text: '商品列表菜单栏',
            isShow: _this5.tableDataFour.filter(function (i) {
              return i.myType * 1 === 13;
            }).length > 0 ? _this5.tableDataFour.filter(function (i) {
              return i.myType * 1 === 13;
            })[0].isShow : 1,
            myType: 13
          }, {
            text: '底部导航栏',
            isShow: 1,
            myType: 14
          });
          console.log(arr);
          _this5.baseData = arr;
        }
      }).then(function () {
        // console.log(this.baseData, '=============')
        _this5.baseData.map(function (i) {
          if (i.category * 1 === 5 && i.id) {
            _this5.getHeaderMsg(i.id);
          } else if (i.category * 1 === 12 && i.id) {
            _this5.getHorseList(i.id);
          }
        });
        // this.getHeaderMsg()
        // this.getHorseList()
      });
    },
    initData: function initData() {
      var _this6 = this;
      var arr = this.baseData.filter(function (i) {
        return i.category;
      }).map(function (i) {
        return {
          modelName: i.text,
          locations: [],
          category: i.category,
          backgroundMode: '',
          backgroundContent: '',
          enable: i.isShow
        };
      });
      (0, _creatApp.initBannerModel)({
        region: 1,
        items: arr
      }).then(function () {
        _this6.findAll();
      });
    },
    saveDiamond: function saveDiamond(val, index) {
      var _this7 = this;
      console.log(val, index);
      if (val.input && val.num && val.status !== '') {
        var buff = val.code ? _creatApp.updateLocation : _creatApp.saveLocation;
        buff({
          id: this.outCategory,
          location: {
            locationCode: val.code ? val.code : new Date().getTime(),
            locationName: val.input,
            sort: val.num * 1,
            enable: val.status
          }
        }).then(function () {
          _this7.getLocationList();
          _this7.findAll();
          _this7.$notify.success({
            title: '温馨提示',
            message: '操作成功'
          });
        });
      } else {
        this.$message({
          type: 'error',
          message: '请填写完整的内容'
        });
      }
    },
    getLocationList: function getLocationList() {
      var _this8 = this;
      (0, _creatApp.getLocations)({
        id: this.outCategory
      }).then(function (res) {
        if (res.data) {
          _this8.diamondTypeList = [];
          _this8.diamondTypeList = res.data.map(function (i) {
            return {
              input: i.locationName,
              code: i.locationCode,
              boole: true,
              status: i.enable,
              num: i.sort
            };
          });
        } else {
          _this8.diamondTypeList = [];
        }
      });
    },
    delDiamond: function delDiamond(val, index) {
      var _this9 = this;
      this.$confirm('确定是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // deleteLocation
        if (val.code) {
          console.log(val);
          (0, _creatApp.deleteLocation)({
            id: _this9.outCategory,
            location: {
              locationCode: val.code,
              locationName: val.input,
              sort: val.num,
              enable: val.status
            }
          }).then(function () {
            _this9.getLocationList();
            _this9.findAll();
            _this9.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        } else {
          _this9.diamondTypeList.splice(index, 1);
          _this9.$notify.success({
            title: '温馨提示',
            message: '操作成功'
          });
        }
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    addDiamond: function addDiamond() {
      this.diamondTypeList.push({
        input: '',
        num: '',
        status: '',
        boole: false,
        code: ''
      });
    },
    changeStatus: function changeStatus(val) {
      var _this0 = this;
      this.$confirm(val.isShow === 0 ? '确定关闭此模块?' : '确定开启此模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (val.category) {
          (0, _creatApp.updateBannerModelStatus)({
            id: val.id,
            enable: val.isShow
          }).then(function () {
            _this0.findAll();
            _this0.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        } else {
          switch (val.myType) {
            case 1:
              _this0.tableData.map(function (i) {
                if (i.myType === val.myType) {
                  i.isShow = val.isShow;
                }
              });
              break;
            case 13:
              _this0.tableDataFour.map(function (i) {
                if (i.myType === val.myType) {
                  i.isShow = val.isShow;
                }
              });
              break;
            case 14:
              _this0.tableDataFif.map(function (i) {
                if (i.myType === val.myType) {
                  i.isShow = val.isShow;
                }
              });
              break;
          }
          var obj = {
            1: _this0.tableData,
            13: _this0.tableDataFour,
            14: _this0.tableDataFif
          };
          (0, _creatApp.saveSetting)({
            appId: _this0.$store.getters.appId,
            itemKey: "home_".concat(val.myType),
            itemValue: JSON.stringify(obj[val.myType])
          }).then(function (res) {
            _this0.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          });
        }
      }).catch(function () {
        _this0.$message({
          type: 'info',
          message: '已取消'
        });
        if (val.isShow === 1) {
          val.isShow = 0;
        } else {
          val.isShow = 1;
        }
      });
    },
    getList: function getList() {
      var _this1 = this;
      var obj = {
        1: this.tableData,
        // 2: this.tableDataTwo,
        // 3: this.tableDataThree,
        13: this.tableDataFour,
        14: this.tableDataFif
      };
      var arr = [];
      for (var i in obj) {
        arr.push("home_".concat(i));
      }
      (0, _creatApp.getConfigList)({
        appId: this.$store.getters.appId,
        itemKeyList: arr
      }).then(function (res) {
        res.data.map(function (i) {
          switch (i.itemKey) {
            case 'home_1':
              _this1.tableData = JSON.parse(i.itemValue);
              break;
            case 'home_13':
              _this1.tableDataFour = JSON.parse(i.itemValue);
              break;
            case 'home_14':
              _this1.tableDataFif = JSON.parse(i.itemValue);
              break;
            default:
              break;
          }
        });
      });
    },
    save: function save() {
      var _this10 = this;
      console.log(this.activeNum, this.baseData[this.activeNum - 1].isShow);
      var obj = {
        1: this.tableData,
        13: this.tableDataFour,
        14: this.tableDataFif
      };
      (0, _creatApp.saveSetting)({
        appId: this.$store.getters.appId,
        itemKey: "home_".concat(this.activeNum),
        itemValue: JSON.stringify(obj[this.activeNum])
      }).then(function (res) {
        _this10.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
      });
    },
    handleChildData: function handleChildData(val) {
      var _this11 = this;
      this.activeNum = val;
      if (val !== 1 && val !== 13 && val !== 14) {
        if (val === 5) {
          this.baseData.map(function (i) {
            if (i.category * 1 === val) {
              _this11.$refs.HeadlineManagementPopup.open({
                id: i.id
              });
            }
          });
        } else if (val === 12) {
          this.baseData.map(function (i) {
            if (i.category * 1 === val) {
              _this11.$refs.HorseRaceLampPopup.open({
                id: i.id
              });
            }
          });
        } else {
          this.baseData.map(function (i) {
            if (i.category * 1 === val) {
              _this11.$refs.ModulePopup.open({
                name: i.text,
                id: i.id,
                region: i.region,
                category: i.category
              });
            }
          });
        }
      }
    },
    dataBuff: function dataBuff() {
      // 确保第一次进来可以刷新子组件
      this.tableData.splice(0, 0);
      this.tableDataFour.splice(0, 0);
      this.tableDataFif.splice(0, 0);
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val, text) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              pictureUrl = '';
              if (!(text === 'selectUrl' || text === 'normalUrl')) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file, 'builds', val.type + '_' + text + '.png');
            case 2:
              pictureUrl = _context.v;
              _context.n = 5;
              break;
            case 3:
              _context.n = 4;
              return (0, _ossUpload.uploadOSS)(file);
            case 4:
              pictureUrl = _context.v;
            case 5:
              if (text) {
                val[text] = pictureUrl + '?pic=' + Math.random();
              } else {
                val.url = pictureUrl;
              }
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.log('error ->', _t);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[1, 6]]);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    del: function del(val, text) {
      var _this12 = this;
      this.$confirm('是否确认要删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this12.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
        if (text) {
          val[text] = '';
        } else {
          val.url = '';
        }
      }).catch(function () {
        _this12.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};